const POSITION_LOCATION_CLAIM_KEY = "position_location";

type Translate = (key: string) => string;

function asString(value: unknown): string | undefined {
  return typeof value === "string" && value.trim() ? value.trim() : undefined;
}

export function formatClientInputClaimValue(
  key: string,
  value: unknown,
  options?: {
    locale?: string;
    t?: Translate;
  }
): string {
  const locale = options?.locale ?? "en";
  const t = options?.t ?? ((label: string) => label);

  if (value == null) {
    return "";
  }

  if (typeof value === "string" || typeof value === "number") {
    return String(value).trim();
  }

  if (typeof value === "boolean") {
    return String(value);
  }

  if (
    key !== POSITION_LOCATION_CLAIM_KEY ||
    typeof value !== "object" ||
    Array.isArray(value)
  ) {
    return "";
  }

  const location = value as Record<string, unknown>;
  const address =
    location.address &&
    typeof location.address === "object" &&
    !Array.isArray(location.address)
      ? (location.address as Record<string, unknown>)
      : location;
  const country = asString(address.country);
  const region = asString(address.administrative_division_1);
  const type = asString(location.type);

  let countryName = country;
  try {
    countryName =
      (country &&
        new Intl.DisplayNames([locale], { type: "region" }).of(country)) ||
      country;
  } catch {
    countryName = country;
  }

  return [
    countryName,
    region?.replace(country ? `${country}-` : /^[A-Z]{2}-/, ""),
    asString(address.locality),
    type === "REMOTE" || type === "REMOTELY"
      ? t("Remote")
      : type === "NO_SPECIFIC_ADDRESS"
        ? t("No specific address")
        : undefined,
  ]
    .filter((part): part is string => Boolean(part))
    .join(", ");
}
